<template>
    <div class="w-view-shell">
        <!-- 面包屑  -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="'/'">首页</el-breadcrumb-item>
            <el-breadcrumb-item>开始学习</el-breadcrumb-item>
            <el-breadcrumb-item>模拟练习</el-breadcrumb-item>
            <el-breadcrumb-item>购买试题</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="maxbox">
            <van-cell-group>
                <van-cell title="单元格">
                    <template #title>
                        <img src="@/assets/amd.png" alt=""/>
                        <span class="span"
                        >{{qst_name}}</span
                        >
                        <div class="div">类别：食品安全培训</div>
                    </template>
                    <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                    <template #right-icon>
                        <span class="price">￥{{qst_price}}</span>
                    </template>
                </van-cell>
            </van-cell-group>
            <div class="btn">
              <el-button @click="buy_topic(1)">余额支付</el-button>
              <el-button @click="buy_topic(2)">微信支付</el-button>
            </div>
        </div>

        <!-- 支付的弹出框 -->
        <div class="coupon-popup-shell" v-if="pay_popup" @click.stop="clear_pay_timer">
            <div class="pay-content" @click.stop="">
                <div class="pay-content-header">
                    <div class="title">扫一扫付款 (元)</div>
                    <div class="pay-price">￥{{pay_money}}</div>
                </div>
                <div class="qrcode-list">
                    <div class="qrcode-box">
                        <div id="qrcode" ref="qrcode" style="width: 160px;height: 160px;" class="ewm"></div>
                        <div class="text">
                            <img class="img" src="@/assets/weixin.png" alt=""/>
                            <span>微信支付</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  
  export default {
    name: 'purchases',
    data () {
      return {
        qst_id: '',
        qst_name: '',
        qst_price: '0.00',
        pay_popup: false,
        pay_timer: null,
      }
    },
    watch: {
      pay_popup: function () {
        if (!this.pay_popup) {
          this.clear_pay_timer()
        }
      }
    },
    mounted () {
      if (this.$route.query.qst_id) {
        this.qst_id = this.$route.query.qst_id
        this.qst_name = this.$route.query.qst_name
        this.qst_price = this.$route.query.qst_price
      }
    },
    methods: {
      buy_topic (pay_way) {
        this.API.post2('user/question_in-buy_question', {
          qst_id: this.qst_id,
          is_h5: 2,
          pay_way: pay_way // 1 余额 2 微信
        }).then((res) => {
          if(res.errno==0){
            if (pay_way == 1) {
              this.$router.push('/test?qst_id=' + this.qst_id)
            } else {
              this.pay_popup = true
              this.pay_money = this.qst_price
              setTimeout(() => {
                this.make(res.data.pay_info.pay_info.code_url)
                let order_id = res.data.order_id
                this.pay_timer = setInterval(() => {
                  this.get_order_detail(order_id)
                }, 1000)
              }, 100)
            }
          } else{
            this.API.SMessage(res.message)
          }
        })
      },
      make (linkUrl) {
        this.$refs.qrcode.innerHTML = '' // 防止重复生成
        let qrcode = new QRCode('qrcode', {
          width: 160,
          height: 160,
          text: linkUrl,
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      get_order_detail (order_id) {
        this.API.post('user/user_infos-order_detail', {
          order_id: order_id,
        }).then((res) => {
          if (res.data.order_info.order_status != '待付款') {
            this.$message({
              showClose: true,
              message: '购买成功',
              type: 'success',
            })
            this.$router.push('/test?qst_id=' + this.qst_id)
          }
        })
      },
      clear_pay_timer () {
        this.pay_popup = false
        window.clearInterval(this.pay_timer)
      },
    }
  }
</script>

<style lang="less" scoped>
    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
        font-weight: 400;
        color: #000;
        cursor: text;
    }

    .el-breadcrumb {
        height: 47px;
        font-size: 16px;
        margin: 20px 0;
        line-height: 47px;
    }

    .maxbox {
        position: relative;
        width: 1200px;
        height: 831px;
        margin-bottom: 30px;
        border: 1px solid #ccc;

        .btn {
          position: absolute;
          right: 30px;
          top: 150px;
          .el-button {
              background: #18949c;
              border-radius: 5px;
              color: #ffffff;
          }
        }
    }

    .van-cell-group {
        position: relative;
        top: 20px;
        left: 50%;
        transform: translate(-50%);
        width: 1140px;
        height: 116px;
        background: #ffffff;
        border: 1px solid #e5e5e5;

        img {
            position: absolute;
            top: 40%;
            left: 40px;
            transform: translate(-50%);
            float: left;
            width: 39px;
            height: 35px;
        }

        .span {
            line-height: 55px;
            margin-left: 60px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;
        }

        .div {
            margin-left: 60px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
        }

        .price {
            position: absolute;
            top: 45%;
            right: 0;
            transform: translate(-50%);
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #eb2020;
        }
    }

    .coupon-popup-shell {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 9;
        background-color: rgba(0, 0, 0, .5);

        .pay-content {
            width: 1050px;
            height: 574px;
            background: #FFFFFF;
            border-radius: 10px;
            padding: 80px;

            .pay-content-header {
                text-align: center;

                .title {
                    font-size: 26px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                }

                .pay-price {
                    font-size: 40px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #D8251C;
                    margin-top: 20px;
                }
            }

            .qrcode-list {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 50px;

                .qrcode-box {
                    width: 210px;
                    height: 210px;
                }

                .text {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 30px;

                    img {
                        width: 25px;
                        height: 22px;
                        margin-right: 10px;
                    }
                }
            }
        }

        .coupon-popup-content {
            width: 1050px;
            min-width: 1050px;
            height: 574px;
            background: #FFFFFF;
            border-radius: 10px;
            padding: 80px 40px;
            position: relative;

            .coupon-list {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-wrap: wrap;
                width: 100%;
                height: 100%;
                overflow-x: hidden;
                overflow-y: scroll;

                .coupon-box {
                    width: 210px;
                    min-width: 210px;
                    height: 237px;
                    min-height: 237px;
                    margin-right: 30px;
                    background-image: url("../../../../assets/222222.png");
                    background-size: 100% 100%;
                    margin-bottom: 60px;
                    cursor: pointer;

                    .info-header {
                        height: 60%;

                        .info-tips {
                            text-align: center;
                            font-size: 36px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #FFFDFD;
                            padding-top: 40px;
                        }

                        .info-price {
                            text-align: center;
                            font-size: 18px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #FDFBFB;
                        }
                    }

                    .info-bottom {
                        height: 40%;
                        text-align: center;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #333333;
                        padding-top: 20px;

                        .info-desc {
                            margin-bottom: 10px;
                        }
                    }
                }
            }

            .coupon-handle {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                width: 100%;
                bottom: 10px;
                left: 10px;
                z-index: 9;
                cursor: pointer;

                .handle-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 116px;
                    height: 46px;
                    border: 1px solid #2AA9B5;
                    border-radius: 5px;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #2AA9B5;
                    margin-right: 40px;
                }

                .handle-btn2 {
                    background: #2AA9B5;
                    color: #fff;
                }
            }
        }

        .select-box {
            width: 24px;
            height: 24px;
            margin: 10px auto 0;
            border: 1px solid #cccccc;
            border-radius: 50%;
        }
    }
</style>
